const enabled = (value) => value === 'true';

export const releaseFeatures = Object.freeze({
  reviews: enabled(process.env.REACT_APP_REVIEWS_ENABLED),
});
